import type { ReactNode } from 'react';
import Banner from '@savvy-kit/patterns/banner';
import { ErrorBoundary } from 'react-error-boundary';

import { CLIENT_PORTAL_SURFACE_ERROR_DESCRIPTION, CLIENT_PORTAL_SURFACE_ERROR_TITLE } from './constants';

type ClientPortalSurfaceBoundaryProps = {
  readonly pathname: string;
  readonly children?: ReactNode;
};

export function ClientPortalSurfaceBoundary({ pathname, children }: ClientPortalSurfaceBoundaryProps) {
  return (
    <ErrorBoundary
      key={pathname}
      fallbackRender={() => (
        <div className="m-9">
          <Banner
            variant="destructive"
            title={CLIENT_PORTAL_SURFACE_ERROR_TITLE}
            description={CLIENT_PORTAL_SURFACE_ERROR_DESCRIPTION}
          />
        </div>
      )}
      onError={(error, info) => {
        console.error(error, info);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
